import { CSSProperties, ReactNode } from 'react';

export type StepState = 'todo' | 'active' | 'done' | 'failed';

export type Step = { title: string; detail?: string; state: StepState; extra?: ReactNode };

const DOT: Record<StepState, CSSProperties> = {
  todo: { borderColor: 'var(--bui-border-2)', color: 'var(--bui-fg-secondary)' },
  active: { borderColor: 'var(--bui-fg-info)', color: 'var(--bui-fg-info)' },
  done: {
    background: 'var(--bui-fg-success)',
    borderColor: 'var(--bui-fg-success)',
    color: 'var(--bui-bg-neutral-1)',
  },
  failed: {
    background: 'var(--bui-fg-danger)',
    borderColor: 'var(--bui-fg-danger)',
    color: 'var(--bui-bg-neutral-1)',
  },
};

const TITLE: Partial<Record<StepState, CSSProperties>> = {
  active: { color: 'var(--bui-fg-info)' },
  failed: { color: 'var(--bui-fg-danger)' },
};

const glyph = (state: StepState, index: number) =>
  state === 'done' ? '✓' : state === 'failed' ? '✕' : String(index + 1);

export const Stepper = ({ steps }: { steps: Step[] }) => (
  <ol style={{ listStyle: 'none', margin: 0, padding: 0 }} aria-live="polite">
    {steps.map((step, i) => (
      <li
        key={step.title}
        style={{ display: 'flex', gap: 12, paddingBottom: i === steps.length - 1 ? 0 : 16, position: 'relative' }}
      >
        {i < steps.length - 1 && (
          <span
            aria-hidden
            style={{
              position: 'absolute',
              left: 9,
              top: 22,
              bottom: 0,
              width: 2,
              background: 'var(--bui-border-1)',
            }}
          />
        )}
        <span
          aria-hidden
          style={{
            flex: '0 0 20px',
            height: 20,
            borderRadius: '50%',
            border: '2px solid',
            background: 'var(--bui-bg-neutral-1)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 11,
            marginTop: 1,
            zIndex: 1,
            ...DOT[step.state],
          }}
        >
          {glyph(step.state, i)}
        </span>
        <div style={{ minWidth: 0 }}>
          <div style={{ fontWeight: 600, fontSize: 13.5, ...TITLE[step.state] }}>
            {step.title}
          </div>
          {step.detail && (
            <div style={{ fontSize: 12.5, color: 'var(--bui-fg-secondary)' }}>
              {step.detail}
            </div>
          )}
          {step.extra}
        </div>
      </li>
    ))}
  </ol>
);
